export default __webpack_public_path__ + "static/media/bookmark.e6409daa.png";